import {
    AccessPermissionRoles,
    AccessRoles,
    CSVUploadData,
    PermissionRoles,
} from "../../models/models";

export interface Option {
    id: number;
    name: string;
}

export type OptionList = {
    id: number;
    name: string;
    data?: DataOption;
}[];

type DataOption = boolean | string | undefined;

export type OptionWCheckbox = {
    id: number;
    name: string;
    dateSelected?: DataOption;
    checked: boolean;
};

export type OptionWCheckboxList = OptionWCheckbox[];

export type ActiveOptionsProperty = (
    options: OptionWCheckboxList | undefined
) => ActiveOptions;

export type ActiveOption =
    | { name: string; id: number; data?: DataOption }
    | undefined;
export type ActiveOptions = ActiveOption[];
export type ActiveOptionsHandler = (
    activeOptions: ActiveOptions | undefined
) => void;
export type ActiveOptionHandler = (
    activeOption: ActiveOption | undefined
) => void;

export const getActiveOptions: ActiveOptionsProperty = (options) => {
    return (options ?? []).reduce(
        (acc: ActiveOptions, option: OptionWCheckbox) => {
            if (option.checked) {
                acc.push({
                    id: option.id,
                    name: option.name,
                    data: option.dateSelected,
                });
            }
            return acc;
        },
        []
    ) as {
        name: string;
        id: number;
        dateSelected?: DataOption;
    }[];
};

type AreAccessPermissions = (
    accessPermissionsRole: AccessPermissionRoles | Array<AccessPermissionRoles>,
    accessorKey: PermissionRoles
) => boolean;

export const areAccessPermissions: AreAccessPermissions = (
    accessPermissions,
    accessorKey
) => {
    if (accessPermissions === AccessRoles.ALL) {
        return true;
    } else if (accessPermissions === accessorKey) {
        return true;
    } else if (Array.isArray(accessPermissions)) {
        return accessPermissions.includes(accessorKey);
    } else {
        return false;
    }
};

type HasPermission = (
    userPermissions: string[] | undefined,
    requiredPermission: string | string[]
) => boolean;

// Action-level access check: does the current user hold the required
// permission(s)? An array means "any of" (OR). Role-based routing/navigation
// stays on areAccessPermissions.
export const hasPermission: HasPermission = (
    userPermissions,
    requiredPermission
) => {
    if (!userPermissions || userPermissions.length === 0) {
        return false;
    }
    if (Array.isArray(requiredPermission)) {
        return requiredPermission.some((permission) =>
            userPermissions.includes(permission)
        );
    }
    return userPermissions.includes(requiredPermission);
};

type FileToBase64 = (file: File) => Promise<string | ArrayBuffer | null>;

export const fileToBase64: FileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsText(file, "UTF-8");
        reader.onload = (readerEvent) => {
            if (readerEvent.target) {
                const utf8String = readerEvent.target.result as string;
                const base64String = btoa(utf8String);
                // console.log('Base64 String:', base64String);
                resolve(base64String as string);
            }
        };
        reader.onerror = (error) => reject(error);
    });
};

export function prepareCSVUploadData(
    e: React.ChangeEvent<HTMLInputElement>,
    forceOverride: boolean
): FormData {
    let files: FileList | null = e.target.files;
    const formData = new FormData();

    Array.from(files ?? []).forEach((file) => {
        formData.append("csvFiles", file);
    });

    formData.append("Options.ForceOverride", forceOverride ? "true" : "false");
    return formData;
}
